export const splitParagraphs = (string) => {
  const regExp = /.+?(?=\n\n)/gm;
  if (string.match(regExp)) {
    return string.match(regExp);
  }
  return [string];
};

export const temp = null;
